export default __webpack_public_path__ + "static/media/Pendant of Blessing.faf86700.jpg";